import { render, staticRenderFns } from "./WalletPage.vue?vue&type=template&id=eb2a217e&scoped=true&"
import script from "./WalletPage.vue?vue&type=script&lang=js&"
export * from "./WalletPage.vue?vue&type=script&lang=js&"
import style0 from "./WalletPage.vue?vue&type=style&index=0&id=eb2a217e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb2a217e",
  null
  
)

export default component.exports